import React from 'react';

const stroke = { stroke: "currentColor", strokeWidth: 1.7, strokeLinecap: "round", strokeLinejoin: "round", fill: "none" };

const DashboardIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>
);
const StudentsIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="3"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
);
const StudentFormIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z"/><path d="M14 3v5h5"/><path d="M12 11v6"/><path d="M9 14h6"/></svg>
);
const RoomsIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><path d="M5 10V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3"/><path d="M8 10v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-8"/><path d="M3 20h18"/></svg>
);
const SeatsIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><path d="M6 10V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5"/><rect x="4" y="10" width="16" height="6" rx="2"/><path d="M6 16v5"/><path d="M18 16v5"/></svg>
);
const LibrariesIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><path d="M4 21V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v13"/><path d="M3 21h18"/><path d="M8 10h2M8 13h2M12 10h2M12 13h2M16 10h2M16 13h2"/><path d="M4 6l8-3 8 3"/></svg>
);
const EmployeesIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="20" style={stroke}><circle cx="12" cy="8" r="3"/><path d="M8 15a4 4 0 0 1 8 0v1H8v-1Z"/><path d="M18 8l1 1 2-2"/></svg>
);
const PaymentsIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>
);
const ReportsIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><path d="M3 3v18h18"/><path d="M7 16V10"/><path d="M12 16V7"/><path d="M17 16v-5"/></svg>
);
export function SettingsIcon({ size = 20, strokeWidth = 1.7, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
const ProfileIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><circle cx="12" cy="8" r="3.5"/><path d="M5.5 19a6.5 6.5 0 0 1 13 0"/></svg>
);
const SetupIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" style={stroke}><circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 0 1 4 2c0 1.5-2 2-2 3.5"/><path d="M12 17h.01"/></svg>
);

const navigation = [
  { group: 'Overview', items: [[<DashboardIcon/>,'Dashboard']] },
  { group: 'Student Management', items: [[<StudentsIcon/>,'Students'],[<StudentFormIcon/>,'Add Student']] },
  { group: 'Facilities', items: [[<LibrariesIcon/>,'Libraries'],[<RoomsIcon/>,'Rooms'],[<SeatsIcon/>,'Seats']] },
  { group: 'Finance', items: [[<PaymentsIcon/>,'Payments']] },
  { group: 'Reports & Insights', items: [[<ReportsIcon/>,'Reports']] },
  { group: 'Team Administration', items: [[<EmployeesIcon/>,'Employees']] },
  { group: 'Account', items: [[<ProfileIcon/>,'Profile'],[<SettingsIcon/>,'Settings'],[<SetupIcon/>,'Setup Guide']] },
];
const navPage = { 'Add Student': 'Student Form' };

export function StudyRoomSymbol() {
  return (
    <span className="brand-mark" role="img" aria-label="Study Room">
      <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
        <rect className="study-logo-frame" width="160" height="160" rx="23" />
        <rect className="study-logo-paper" x="5" y="5" width="150" height="150" rx="18" />
        <circle className="study-logo-ink" cx="80" cy="39" r="21" />
        <path className="study-logo-ink" d="m49 62 31 13 31-13-4 17-27 13-27-13-4-17Z" />
        <path className="study-logo-ink" d="M38 73 76 86v53L38 119V73Zm46 13 38-13v46l-38 20V86Z" />
        <path className="study-logo-ink" d="M38 84H29a8 8 0 0 0 0 16h9V84Zm84 0h9a8 8 0 0 1 0 16h-9V84Z" />
      </svg>
    </span>
  );
}

export function Sidebar({ page, setPage, collapsed, setCollapsed, showPayments, setShowPayments, onSignOut }) {
  return <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
    <div className="brand"><StudyRoomSymbol /><span className="brand-copy"><b>Study Room</b><small>Workspace</small></span></div>
    <div className="side-scroll">{navigation.map((section) => <div className="nav-section" key={section.group}>
      <div className="section-label">{section.group}</div>
      {section.items.map(([icon, label]) => {
        const target = navPage[label] || label;
        const selected = page === target || (label === 'Payments' && page === 'Payment Plans');
        return <React.Fragment key={label}>
          <button className={`nav-item ${selected ? 'selected' : ''} ${label === 'Payments' ? 'has-subnav' : ''}`} title={collapsed ? label : undefined} aria-current={page === target || (label === 'Payments' && page === 'Payment Plans') ? 'page' : undefined} aria-expanded={label === 'Payments' ? showPayments : undefined} onClick={() => {
            if (label === 'Payments') {
              if (collapsed) {
                setCollapsed(false);
                setShowPayments(true);
              } else {
                setShowPayments((value) => !value);
              }
            }
            else setPage(target);
          }}>
            <span className="nav-icon">{label === 'Profile' ? <svg className="student-outline" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3.25"/><path d="M19 21v-2a7 7 0 0 0-14 0v2h14"/></svg> : icon}</span>
            <span className="nav-label">{label}</span>{label === 'Payments' && <span className={`nav-caret ${showPayments ? 'expanded' : ''}`} aria-hidden="true"><svg viewBox="0 0 16 16"><path d="m4 6 4 4 4-4"/></svg></span>}
          </button>
          {label === 'Payments' && <div className={`payment-subnav ${showPayments ? 'open' : ''}`}>
            <button className={page === 'Payment Plans' ? 'selected' : ''} aria-current={page === 'Payment Plans' ? 'page' : undefined} onClick={() => { setPage('Payment Plans'); setShowPayments(true); if (window.innerWidth <= 760) setCollapsed(true); }}>Plans &amp; Pricing</button>
            <button className={page === 'Payments' ? 'selected' : ''} aria-current={page === 'Payments' ? 'page' : undefined} onClick={() => { setPage('Payments'); setShowPayments(true); if (window.innerWidth <= 760) setCollapsed(true); }}>Payment Records</button>
          </div>}
        </React.Fragment>;
      })}
    </div>)}</div>
    <div className="sidebar-footer">
      <div className="sidebar-branding">
        <StudyRoomSymbol />
        <span className="brand-copy">
          <b>Study Room</b>
          <small>Workspace</small>
          <em>© 2026 Study Room</em>
        </span>
      </div>
      <button className="logout" onClick={onSignOut} title={collapsed ? 'Sign out' : undefined}>
        <span className="logout-icon" aria-hidden="true">
          <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" focusable="false">
            <path d="M7.5 1v7h1V1z" />
            <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" />
          </svg>
        </span>
        <span className="nav-label">Sign out</span>
      </button>
    </div>
  </aside>;
}
